// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__U18Rm","title":"style_title__2kPLt","content":"style_content__+nQb+"};